<template>
    <div>
        <el-container>
            <el-header height="120px" style="background-color:skyblue;">
                <div class="demo-input-suffix">
                    <el-row :gutter="20" style="margin-top: 10px;">
                        <el-col :span="el_col_span">
                            用户姓名
                            <el-input v-model="form.user_name" readonly label="" :style="el_input_width"
                                size="mini"></el-input>
                        </el-col>
                        <el-col :span="el_col_span">
                            用户性别
                            <el-input v-model="form.user_gender_text" readonly :style="el_input_width"
                                size="mini"></el-input>
                        </el-col>
                        <el-col :span="el_col_span">
                            联系方式
                            <el-input v-model="form.user_mobile" readonly :style="el_input_width"
                                size="mini"></el-input>
                        </el-col>
                        <el-col :span="el_col_span">
                            注册时间
                            <el-input v-model="form.create_time" readonly :style="el_input_width"
                                size="mini"></el-input>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20" style="margin-top: 20px;">
                        <el-col :span="el_col_span">
                            用户卡号
                            <el-input v-model="form.user_card.card_number" readonly :style="el_input_width"
                                size="medium"></el-input>
                        </el-col>
                        <el-col :span="el_col_span">
                            卡号类型
                            <el-input v-model="form.user_card.card_type.card_type_name" readonly :style="el_input_width"
                                size="medium"></el-input>
                        </el-col>
                        <el-col :span="el_col_span">
                            卡内余额
                            <el-input v-model="form.user_card.card_balance" readonly :style="el_input_width"
                                size="medium"></el-input>
                        </el-col>
                        <el-col :span="el_col_span">
                            卡有效期
                            <el-input v-model="form.user_card.expiry_date" readonly :style="el_input_width"
                                size="medium"></el-input>
                        </el-col>
                    </el-row>
                </div>

            </el-header>

            <el-main>
                <el-table :data="tableData" border style="width: 100%">
                    <el-table-column label="交易ID" prop="trans_id" width="100px">
                    </el-table-column>
                    <el-table-column label="订单ID" prop="order_id" width="100px">
                    </el-table-column>
                    <el-table-column label="交易时间" prop="create_time" width="220px">
                    </el-table-column>
                    <el-table-column prop="service_type_text" label="交易类型" width="140px">
                        <template slot-scope="scope">
                            <el-tag effect="dark" :type="scope.row.trans_type_type">
                                {{ scope.row.trans_type }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="service_name" label="服务名称" width="150px">
                    </el-table-column>
                    <el-table-column prop="card_type" label="用户卡类型" width="140px">
                        <template slot-scope="scope">
                            <el-tag effect="dark" :type="scope.row.card_type_type">
                                {{ scope.row.card_type }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="trans_volume" label="交易量" width="120px">
                    </el-table-column>
                    <el-table-column prop="trans_person_number" label="订单人数" width="120px">
                    </el-table-column>
                    <el-table-column prop="trans_amount" label="充值金额" width="120px">
                    </el-table-column>
                    <el-table-column prop="card_balance" label="卡余额（次数）" width="150px">
                    </el-table-column>
                    <el-table-column prop="order_status_text" label="交易状态" width="120px">
                        <template slot-scope="scope">
                            <el-tag effect="dark" :type="scope.row.trans_status_type">
                                {{ scope.row.trans_status }}
                            </el-tag>
                        </template>
                    </el-table-column>

                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button type="danger" @click="btn_undo(scope.row)" v-if="scope.row.trans_type === '充值'">
                                撤销
                            </el-button>
                        </template>
                    </el-table-column>

                </el-table>

            </el-main>
        </el-container>
    </div>
</template>

<script>
import { getTransRecord, undoTransaction } from '@/api/order';
import { SERVICE_TYPE_ENUM, ORDER_STATUS_ENUM, TRANSACTION_TYPE_ENUM, CARD_TYPE_ENUM } from '@/api/constants';

export default {
    // watch: {
    //     $route() {
    //         window.location.reload()
    //     }
    // },
    computed: {
        showUndo(row) {
            console.log(row)
            return row.trans_type === TRANSACTION_TYPE_ENUM.RECHARGE.value
        }
    },

    data() {
        return {
            tableData: [],
            form: {
                user_name: '',
                user_gender: '',
                user_mobile: '',
                user_card: {
                    card_type: '',
                    card_number: ''
                }
            },
            el_input_width: "width:200px",
            el_col_span: 6,
        }
    },
    methods: {
        onSubmit() {
            console.log('submit!');
        },

        btn_undo(row) {
            console.log(row)
            undoTransaction(row).then((res) => {
                if (res.status === 200) {
                    if (res.data.code === 0) {
                        this.$message({ message: res.data.msg, type: 'success' })
                    } else {
                        this.$message({ message: res.data.msg, type: 'error' })
                    }
                } else {
                    this.$message({ message: res.data.msg, type: 'error' })
                }
                this.getData(this.$route.params.id)
            })
        },

        getData(user_id) {
            getTransRecord(user_id).then((res) => {
                if (res.status === 200) {
                    this.form = res.data.data
                    // console.log(this.form)

                    switch (this.form.user_gender) {
                        case 1: this.form.user_gender_text = "男性"; break;
                        case 0: this.form.user_gender_text = "女性"; break;
                        default: this.form.user_gender_text = "未知"; break;
                    }

                    this.tableData = res.data.data['trans_records']
                    this.tableData.forEach(item => {
                        switch (item.trans_type) {
                            case TRANSACTION_TYPE_ENUM.CONSUMPTION.value:
                                item.trans_type_type = 'success';
                                break;
                            case TRANSACTION_TYPE_ENUM.RECHARGE.value:
                                item.trans_type_type = 'danger';
                                break;
                            case TRANSACTION_TYPE_ENUM.PROMOTION.value:
                                item.trans_type_type = 'warning';
                                break;
                            default:
                                item.trans_type_type = 'info';
                                break;
                        }

                        switch (item.trans_status) {
                            case ORDER_STATUS_ENUM.ORDER_STATUS_CANCELED.value:
                                item.trans_status_type = 'danger';
                                break;
                            case ORDER_STATUS_ENUM.ORDER_STATUS_COMPLETED.value:
                                item.trans_status_type = 'success';
                                break;
                            case ORDER_STATUS_ENUM.ORDER_STATUS_ORDERED.value:
                                item.trans_status_type = 'info';
                                break;
                            case ORDER_STATUS_ENUM.ORDER_STATUS_USING.value:
                                item.trans_status_type = 'warning';
                                break;
                            default:
                                item.service_type_text = SERVICE_TYPE_ENUM.SERVICE_TYPE_FEATURED.value;
                                item.trans_status_type = 'info';
                                break;
                        }
                        switch (item.card_type) {
                            case CARD_TYPE_ENUM.EXPERIENCE_CARD.value:
                                item.card_type_type = 'primary'
                                break;
                            case CARD_TYPE_ENUM.VIP_CARD.value:
                                item.card_type_type = 'danger'
                                break;
                            case CARD_TYPE_ENUM.VIP_FAMILY_CARD.value:
                                item.card_type_type = 'warning'
                                break;
                        }

                    })

                }
            })

        }
    },
    created() {
        // location.reload()
        this.getData(this.$route.params.id)
    },

}
</script>

<style lang="scss">
.el-form {
    text-align: left;
}

.el-form-item__label {
    font-size: 15px;
    // font-weight: bold;
    align-items: left;

}

.el-input__inner {
    font-size: 14px;
    // font-weight: bold;
}

.el-table th {
    font-size: 18px;
    font-weight: bold;
}

.el-table td {
    font-size: 16px;
    font-weight: bold;

    .el-tag {
        font-size: 16px;
    }
}
</style>